import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './appBar.css'

import { getLeftToolbarActions } from '../../../redux/availableActions/selectors'
import { ThumbnailListContainer } from './ThumbnailList/ThumbnailList'
import { PrintPreviewContainer } from './PrintPreview/PrintPreview'
import { TableOfContentsContainer } from './TableOfContents/TableOfContents'
import { CollaborativeIndexationsContainer } from './CollaborativeIndexations/CollaborativeIndexations'
import { CollaborativeIndexationCreationContainer } from './CollaborativeIndexationCreation/CollaborativeIndexationCreation'
import { ToolbarContainer } from '../Toolbar/Toolbar'
import { ShareContainer } from './Share/Share'

export class AppBar extends Component {

    static propTypes = {
        isCollaborativeIndexationAsideDisplayed: PropTypes.bool.isRequired,
        isCollaborativeIndexationCreationAsideDisplayed: PropTypes.bool.isRequired,
        isThumbnailsAsideDisplayed: PropTypes.bool.isRequired,
        isTableOfContentsAsideDisplayed: PropTypes.bool.isRequired,
        isPrintPreviewAsideDisplayed: PropTypes.bool.isRequired,
        isUserCollaborativeIndexerStatusActive: PropTypes.bool.isRequired,
        isSocialSharingAsideDisplayed: PropTypes.bool.isRequired,
    }

    render() {

        const {
            isCollaborativeIndexationAsideDisplayed,
            isCollaborativeIndexationCreationAsideDisplayed,
            isThumbnailsAsideDisplayed,
            isTableOfContentsAsideDisplayed,
            isPrintPreviewAsideDisplayed,
            isUserCollaborativeIndexerStatusActive,
            isSocialSharingAsideDisplayed,
        } = this.props

        return (
            <div className="app-bar print-hidden">
                <ToolbarContainer type='vertical' name='left' itemsSupplier={getLeftToolbarActions} />

                <div className="app-bar-aside">
                    <div className={classNames('thumbnails-wrapper', 'animate', {'hidden-horizontal': ! isThumbnailsAsideDisplayed })}>
                        { isThumbnailsAsideDisplayed && <ThumbnailListContainer /> }
                    </div>
                    <div className={classNames('print-preview-wrapper', 'animate', {'hidden-horizontal': ! isPrintPreviewAsideDisplayed })}>
                        { isPrintPreviewAsideDisplayed && <PrintPreviewContainer /> }
                    </div>
                    <div className={classNames('table-of-contents-wrapper', 'animate', {'hidden-horizontal': ! isTableOfContentsAsideDisplayed })}>
                        { isTableOfContentsAsideDisplayed && <TableOfContentsContainer /> }
                    </div>
                    <div className={ classNames('collaborative-indexations-wrapper', 'animate', { 'hidden-horizontal': ! isCollaborativeIndexationAsideDisplayed }) }>
                        { isCollaborativeIndexationAsideDisplayed && <CollaborativeIndexationsContainer /> }
                    </div>
                    <div className={ classNames('collaborative-indexations-creation-wrapper', { 'hidden-horizontal': ! isCollaborativeIndexationCreationAsideDisplayed || ! isUserCollaborativeIndexerStatusActive }) }>
                        { isCollaborativeIndexationCreationAsideDisplayed && <CollaborativeIndexationCreationContainer /> }
                    </div>
                    <div className={classNames('share', 'animate', {'hidden-horizontal': ! isSocialSharingAsideDisplayed })}>
                        { isSocialSharingAsideDisplayed && <ShareContainer /> }
                    </div>
                </div>
            </div>
        )
    }
}
